import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";

import './popupGeolocation.component.css';
import { isMobile } from "react-device-detect";

export type popupGeolocationProps = {
    onClose: any;
}

export default function PopupGeolocationComponent(props: popupGeolocationProps) {

    const [codeError, setCodeError] = useState<number>(1);

    useEffect(() => {
        //requestGeolocation();
        if (navigator.geolocation) {
            navigator.permissions
            .query({ name: "geolocation" })
            .then(function (result) {

                if (result.state === "granted") {
                    requestGeolocation();
                //If granted then you can directly call your function here
                } else if (result.state === "prompt") {
                //If prompt then the user will be asked to give permission
                } else if (result.state === "denied") {
                //If denied then you have to show instructions to enable location
                }
            });
        } 
    }, [])

    const footerContent = (
        <></>
        // <div className="flex justify-content-end align-items-center">
        //     <Button className="button-close" label="Chiudi"
        //         onClick={() => { props.onClose() }}
        //     />

        //     <Button label="Ok" icon="pi pi-check" id="enableGeolocation" 
        //         onClick={() => {
        //             if(codeError !== 2) {
        //                 requestGeolocation()
        //             } 
        //         }}
        //     />

        // </div>
    );

    const requestGeolocation = () => {
        navigator.geolocation.watchPosition(getPosition ,errorPosition)
    }

    const getPosition = (position: GeolocationPosition) => {
        console.log(position)
    }

    const errorPosition = (error: GeolocationPositionError) => {
        console.log('error', error);
        setCodeError(error.code)
    }


    return (
        <Dialog 
            visible={true} onHide={() => props.onClose()} 
            className="popup-geolocation"
            header="Geolocalizzazione non attiva" 
            position="bottom" style={{ width: '95%', maxWidth: '500px' }}
        >
        <p className="mt-0">
            {
                codeError === 1
                ?
                <span>
                    La geolocalizzazione non è attiva. Per migliorare questa funzionalità,
                    attiva la geolocalizzazione.
                </span>
                : 
                codeError === 2 && isMobile
                ?
                <span>
                    Posizione non disponibile. Assicurati di aver attiva la posizione GPS.
                </span>
                :
                <></>
            }
          
        </p>
    
      </Dialog>
    )
}